import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import { columns } from './table-column';

export default function CruisePurchaseGuestDetailTable(props: {
  guestIndex: number;
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const name = `approvalable.cruisePurchases.${props.parentIndex}.cruisePurchaseDetails.${props.guestIndex}`;
  const value = HOCWatchValue({ keys: [name] });

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns(t)}
        data={[value[name]]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
